<template>
	
	<article>
    
	    <figure class="img img-sq">
	    	<img v-lazy="post.post_thumbnail.url" :alt="post.post_title"/>
	    </figure>
	    
	    <div class="event-details"><div class="va">
        <span class="event-date text-extended">{{ labelFormat(post.post_date) }}</span>
        <span v-if="post.post_datetime !== null" class="event-date text-extended event-datetime">, {{ timeFormat(post.post_datetime) }}</span>
        <br>
        <h4 class="text-extended"><strong>{{ post.post_title }}</strong></h4>
        
	      <prismic-rich-text :field="post.post_excerpt" class="event-description text-smaller" />
	      
	      <prismic-link v-if="post.cta_text !== null" :field="post.cta_link" class="btn text-smaller">
		    	<span><strong>{{ post.cta_text }}</strong></span>
		    </prismic-link>
			      						
	    </div></div>
	</article>
	
</template>

<script>
import moment from 'moment'

export default {
  name: 'FeaturedPost',
  props: ['post'],
  data () {
    return {
    }
  },
	methods: {
		labelFormat(date) {
			var label = moment(date);
			label = label.format('ddd MMM D');
			return label;
		},
		timeFormat(datetime) {
			var label = moment(datetime);
			label = label.format('H:mma');
			return label;
		}
	},
	created () {
  }
}
</script>

<style>
	@media only screen and (min-width: 64em){
		section#events p {
			width: 100%;
		}
	}


	</style>